import { useCallback, useState } from "react";

export enum CopyStatus {
  Idle = "IDLE",
  Copied = "COPIED",
  Error = "ERROR"
}

export const useCopyToClipboard = () => {
  const [status, setStatus] = useState<CopyStatus>(CopyStatus.Idle);

  const copy = useCallback((text: string) => {
    if (!navigator.clipboard) {
      setStatus(CopyStatus.Error);
      return;
    }

    navigator.clipboard
      .writeText(text)
      .then(() => setStatus(CopyStatus.Copied))
      .catch(() => setStatus(CopyStatus.Error));
  }, []);

  const reset = useCallback(() => setStatus(CopyStatus.Idle), []);

  return { status, copy, reset };
};
